import { LightBulbIcon } from "@heroicons/react/24/outline";
import { TopicLabel } from "../api/Items";
import { useLensTopicsEnabled } from "../reports/helper-components/useLensTopicsEnabled";

function TopicBadges({ topics }: { topics: TopicLabel[] }): JSX.Element | null {
  const lensTopicsEnabled = useLensTopicsEnabled();
  if (!lensTopicsEnabled || topics.length === 0) {
    return null;
  }

  return (
    <span className="inline-flex items-center">
      <span
        className="self-start pr-4 text-gray-700"
        role="img"
        aria-label="Topic"
      >
        <LightBulbIcon className="w-5 h-5" />
      </span>
      <div className="flex flex-wrap gap-2">
        {topics.map((topic) => (
          <span
            className="inline-flex items-center bg-yellow-100 py-1 px-3 rounded-md text-gray-800 text-xs font-medium"
            key={`${topic.lens_topics_uuid}-${topic.topic_group_name}-${topic.label}`}
          >
            {topic.label}
          </span>
        ))}
      </div>
    </span>
  );
}

export default TopicBadges;
